var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldSetting3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm.61 2.75c.41 0 .75.34.75.75v3.9c0 .41-.34.75-.75.75s-.75-.34-.75-.75V5.5c0-.41.34-.75.75-.75zm.75 13.75c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.682a.5.5 0 0 0-.205-.404C6.288 15.554 5.7 14.732 5.7 13.95c0-1.5 1.22-2.73 2.72-2.73 1.5 0 2.73 1.22 2.73 2.73 0 1.24-.84 2.28-1.98 2.61v1.94zm6.41.75c-.41 0-.75-.34-.75-.75v-3.9c0-.41.34-.75.75-.75s.75.34.75.75v3.9c0 .41-.34.75-.75.75zm-2.73-9.21c0-1.24.84-2.28 1.98-2.61V5.5c0-.41.34-.75.75-.75s.75.34.75.75v1.682a.5.5 0 0 0 .205.404c1.177.86 1.765 1.682 1.765 2.464 0 1.5-1.22 2.72-2.72 2.72-1.5 0-2.73-1.22-2.73-2.73z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSetting3);
export default __webpack_public_path__ + "static/media/vuesax-bold-setting-3.4a1f570aadbc14e7f5d3b52c340dc839.svg";
export { ForwardRef as ReactComponent };